import { Event } from '@/types/events';

export const calculateBudgetMetrics = (event: Partial<Event>) => {
  if (!event?.budget?.length) {
    return {
      estimated: 0,
      actual: null,
      variance: 0
    };
  }

  const totalEstimated = event.budget.reduce((sum, item) => sum + item.estimatedCost, 0);
  const totalActual = event.budget.reduce((sum, item) => sum + (item.actualCost || 0), 0);
  
  return {
    estimated: totalEstimated,
    actual: totalActual || null,
    variance: calculateBudgetVariance(totalEstimated, totalActual)
  };
};

export const calculateBudgetVariance = (estimated: number, actual: number): number => {
  if (!actual || !estimated) return 0;
  return ((actual - estimated) / estimated) * 100;
};